export default {
  "LocationDisagreeModal.Title": "位置情報の利用を停止する",
  "LocationDisagreeModal.TextTop":
    "ドコモおよびNTTドコモビジネス株式会社は、以下に記載のドコモまたはNTTドコモビジネス株式会社が取得しているお客さまの位置情報を、以下に記載の利用目的での利用を停止します",
  "LocationDisagreeModal.GettingLocaleTitle": "【利用する位置情報】",
  "LocationDisagreeModal.GettingLocaleContent":
    "移動体端末の所持者の所在を表す場所を示す情報です。例として、端末のGPS機能の他、Wi-Fiまたはその他の近距離無線通信技術、携帯電話基地局により測位される位置情報（位置登録情報を含みますが、これに限りません）などが含まれます",
  "LocationDisagreeModal.PurposeTitle": "【利用目的】",
  "LocationDisagreeModal.PurposeList1":
    "ドコモやドコモの連結子会社および持分法適用会社ならびにNTTの連結子会社および持分法適用会社で利用可能なクーポンなどの特典の進呈、ドコモまたはNTTドコモビジネス株式会社が適切と判断したさまざまな商品・サービス・キャンペーン・イベント（ドコモまたはNTTドコモビジネス株式会社以外の第三者のものを含みます）に関する情報提供や広告の表示・配信のため",
  "LocationDisagreeModal.PurposeList2":
    "ドコモまたはNTTドコモビジネス株式会社の商品やサービスの販売・利用状況の調査および分析、ドコモまたはNTTドコモビジネス株式会社の商品やサービスの運用・向上、新商品や新サービスの企画、アンケート調査その他マーケティング分析のため",
  "LocationDisagreeModal.PurposeAsterisk1":
    "位置情報の利用停止に伴う設定変更が反映される前に取得された位置情報は利用されることがあることを予めご了承ください",
  "LocationDisagreeModal.PurposeAsterisk2":
    "本設定による位置情報の利用停止にかかわらず、ドコモおよびNTTドコモビジネス株式会社は、電気通信役務の提供に必要な範囲等法令により認められる範囲で、または個々のサービス・アプリ等においてお客さまの同意を得ることにより、位置情報を取得・利用しています。なお、個々のサービス・アプリ等において独自に利用する位置情報の利用停止は個々のサービス・アプリ等にて指定する方法にて実施ください",
}
